/* Common stores */
import { expensesAllocationStore } from '@patient/store/ExpensesAllocationStore';
import { configuration } from '@store/Configuration/Configuration';
import { app } from '@store/App/App';
import { viewPort } from '@store/ViewPort';
import { ehr } from '@patient/store/ehr/Ehr';
import { ehrsServicePlans } from '@patient/store/ehr/EhrServicePlans';
import { profileForm } from '@profile/store/ProfileForm';
import { entryTypeList } from '@template/store/entryType/EntryTypeList';
import { entry } from '@patient/store/entry/Entry';
import { dictionary } from '@template/store/dictionary/Dictionary';
import { common } from '@store/common/Common';
import { serviceStore } from '@services/store/service/ServiceStore';
import { authUser } from '@store/AuthUser/AuthUser';
import { authUserCertificates } from '@store/AuthUser/AuthUserCertificates';
import { userList } from '@user/store/UserList';
import { contractList } from '@organization/store/contract/ContractList';
import { organizationList } from '@organization/store/organization/OrganizationList';
import { legalEntityBranchList } from '@organization/store/legalEntityBranch/LegalEntityBranchList';
import { priceListStore } from '@price/store/priceList/PriceListStore';
import { serviceGroupStore } from '@services/store/serviceGroup/ServiceGroupStore';
import { planStore } from '@plan/store/PlanStore';
import { patientStore } from '@patient/store/patient/PatientStore';
import { officeList } from '@organization/store/office/OfficeList';
import { deviceList } from '@organization/store/device/DeviceList';
import { networkList } from '@organization/store/network/NetworkList';
import { laboratoryStore } from '@lab/store/LaboratoryStore';
import { priceStore } from '@price/store/price/PriceStore';
import { legalEntityList } from '@organization/store/legalEntity/LegalEntityList';
import { referralForm } from '@common/ReferralMenu/store/ReferralForm';
import { subscriptionParams } from '@modules/attachment/store/SubscriptionParams';
import { protestStore } from '@insurance/store/ProtestStore';
import { maxPaymentAmountList } from '@store/MaxPaymentAmount/store/MaxPaymentAmountList';
import { paymentsStore } from '@modules/payments/store/PaymentsStore';
import { renderedServiceList } from '@store/RenderedService/RenderedServiceList';
import { entryListStore } from '@store/EntryList/EntryListStore';
import { individualReportsStore } from '@modules/organization/ui/LegalEntityPage/pages/IndividualReportsPage/store/IndividualReportsStore';
import { materialsStore } from './materials/MaterialsStore';
import { entryTypeSpecialityList } from '@store/EntryTypeSpeciality/EntryTypeSpecialtyList';
import { subscriptionUserPriceList } from '@store/SubscriptionUserPriceList/SubscriptionUserPriceList';
import { drugStore } from '@store/drugs/DrugStore';

/* Page stores */
import { entryPage } from '@patient/ui/shared/store';
import { serviceGroupPage } from '@modules/services/ui/ServiceGroupPage/store';
import { billingPageStore } from '@billing/ui/BillingPage/store/BillingPageStore';
import { medicalCaseStore } from '@store/MedicalCase/medicalCaseStore';
import { legalEntityPriceList } from '@store/LegalEntityPriceList/store/LegalEntityPriceList';
import { entriesPageStore } from '@dashboard/ui/pages/EntriesPage/store/EntriesPageStore';
import { referralPageStore } from '@dashboard/ui/pages/ReferralPage/store/ReferralPageStore';
import { renderedServicesPageStore } from '@dashboard/ui/pages/RenderedServicesPage/store/RenderedServicesPageStore';
import { laboratoryServicePageStore } from '@lab/ui/LaboratoryAdmin/pages/LaboratoryServicePage/store/LaboratoryServicePageStore';
import { laboratoryReferencesPageStore } from '@lab/ui/LaboratoryAdmin/pages/LaboratoryReferencesTablePage/store/LaboratoryReferencesPageStore';
import { attachmentStatusList } from '@modules/attachment/store/AttachmentList';

export const store = {
    get ehr() {
        return ehr;
    },
    get configuration() {
        return configuration;
    },
    get app() {
        return app;
    },
    get viewPort() {
        return viewPort;
    },
    get profileForm() {
        return profileForm;
    },
    get entry() {
        return entry;
    },
    get entryTypeList() {
        return entryTypeList;
    },
    get dictionary() {
        return dictionary;
    },
    get entryPage() {
        return entryPage;
    },
    get common() {
        return common;
    },
    get serviceStore() {
        return serviceStore;
    },
    get drugStore() {
        return drugStore;
    },
    get authUser() {
        return authUser;
    },
    get authUserCertificates() {
        return authUserCertificates;
    },
    get userList() {
        return userList;
    },
    get organizationList() {
        return organizationList;
    },
    get priceListStore() {
        return priceListStore;
    },
    get serviceGroupPage() {
        return serviceGroupPage;
    },
    get planStore() {
        return planStore;
    },
    get paymentsStore() {
        return paymentsStore;
    },
    get serviceGroupStore() {
        return serviceGroupStore;
    },
    get patientStore() {
        return patientStore;
    },
    get officeList() {
        return officeList;
    },
    get deviceList() {
        return deviceList;
    },
    get networkList() {
        return networkList;
    },
    get laboratoryStore() {
        return laboratoryStore;
    },
    get priceStore() {
        return priceStore;
    },
    get contractList() {
        return contractList;
    },
    get ehrsServicePlans() {
        return ehrsServicePlans;
    },
    get legalEntityBranchList() {
        return legalEntityBranchList;
    },
    get legalEntityList() {
        return legalEntityList;
    },
    get referralForm() {
        return referralForm;
    },
    get billingPageStore() {
        return billingPageStore;
    },
    get subscriptionParams() {
        return subscriptionParams;
    },
    get individualReportsStore() {
        return individualReportsStore;
    },
    get protestStore() {
        return protestStore;
    },
    get medicalCaseStore() {
        return medicalCaseStore;
    },
    get legalEntityPriceList() {
        return legalEntityPriceList;
    },
    get entriesPageStore() {
        return entriesPageStore;
    },
    get renderedServicesPageStore() {
        return renderedServicesPageStore;
    },
    get referralPageStore() {
        return referralPageStore;
    },
    get maxPaymentAmountList() {
        return maxPaymentAmountList;
    },
    get laboratoryServicePageStore() {
        return laboratoryServicePageStore;
    },
    get renderedServiceList() {
        return renderedServiceList;
    },
    get entryListStore() {
        return entryListStore;
    },
    get materialsStore() {
        return materialsStore;
    },
    get expensesAllocationStore() {
        return expensesAllocationStore;
    },
    get entryTypeSpecialityList() {
        return entryTypeSpecialityList;
    },
    get laboratoryReferencesPageStore() {
        return laboratoryReferencesPageStore;
    },
    get subscriptionUserPriceList() {
        return subscriptionUserPriceList;
    },
    get attachmentStatusList() {
        return attachmentStatusList;
    },
} as const;

export type StoreState = typeof store;
